/**
 * @prettier
 * @author Alexander Nagelberg
 */
import React, { useRef } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { v4 as uuid } from 'uuid'

import { failureTypes } from '../utils/refundUtils'
/**
 * Component for selecting/filtering failure reason. This can be dropped
 * anywhere with no props. It will replace existing filters (status/date
 * picker) when selected and changes the URL to contain ?failure=[reason]
 * in the query upon pressing submit.
 *
 * @since 20.4.5
 * @example
 * <div>
 *   <FailureFilter />
 * </div>
 */
const FailureFilter = () => {
  const { search, pathname } = useLocation()
  const history = useHistory()
  const query = new URLSearchParams(search)
  const reasonRef = useRef()

  const applyFilter = () => {
    if (reasonRef.current.value !== 'NONE') {
      // status xor date
      query.delete('to')
      query.delete('from')
      query.delete('status')

      query.set('failure', reasonRef.current.value)
      history.push(`${pathname}?${query.toString()}`)
    }
  }

  const unique_id = 'FailureFilter' + uuid()

  return (
    <div className='lgy-funding-fee-failure-filter'>
      <label for={unique_id}>Show:</label>

      <select id={unique_id} ref={reasonRef} defaultValue={query.get('failure') ?? 'NONE'}>
        <option value='NONE' disabled>
          -Select Failure Reason-
        </option>
        {Object.keys(failureTypes).map(failureKey => (
          <option value={failureKey} key={failureKey}>
            {failureTypes[failureKey]}
          </option>
        ))}
      </select>
      <button onClick={applyFilter}>Submit</button>
    </div>
  )
}

export default FailureFilter
